<template>
  <v-card>
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="$t('audit.users.search')"
        single-line
        hide-details
      ></v-text-field>

      <v-spacer></v-spacer>

      <v-btn @click="downloadCsv" color="secondary" icon>
        <v-icon>mdi-download</v-icon>
      </v-btn>
    </v-card-title>

    <v-data-table
      :headers="headers"
      :items="items"
      :search="search"
      :no-results-text="$t('audit.users.noResults')"
      :items-per-page="-1"
      dense
      multi-sort
    >
      <template #foot="">
        <tfoot class="totals">
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>{{ totals.minimal }}</td>
            <td></td>
            <td>{{ totals.stepModel }}</td>
            <td></td>
          </tr>
        </tfoot>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { length, filter, map, propEq, pluck, sum, join, split, path } from "ramda";
import { stringify } from "csv-stringify/lib/sync";
import { saveAs } from "file-saver";

export default {
  props: {
    auditPeriods: {
      type: Array,
      required: true,
    },

    year: {
      required: true,
    },
  },

  data() {
    return {
      search: "",
    };
  },

  computed: {
    headers() {
      return [
        {
          text: this.$t("admin.bookings.company"),
          value: "address.name",
        },
        {
          text: this.$t("admin.bookings.contactPerson"),
          value: "address.contactPerson",
        },
        {
          text: this.$t("admin.bookings.email"),
          value: "emails",
        },
        {
          text: this.$t("admin.bookings.address"),
          value: "address.address",
        },
        {
          text: this.$t("admin.bookings.zip"),
          value: "address.zip",
        },
        {
          text: this.$t("admin.bookings.city"),
          value: "address.city",
        },
        {
          text: this.$t("admin.bookings.country"),
          value: "address.country",
        },
        {
          text: this.$t("admin.bookings.vatId"),
          value: "address.vatId",
        },
        {
          text: this.$t("admin.bookings.billingLanguage"),
          value: "address.billingLanguage",
        },
        {
          text: this.$t("admin.bookings.minimalFundsCount"),
          value: "minimalFundsCount",
        },
        {
          text: this.$t("admin.bookings.minimalFunds"),
          value: "minimalFunds",
        },
        {
          text: this.$t("admin.bookings.stepModelFundsCount"),
          value: "stepModelFundsCount",
        },
        {
          text: this.$t("admin.bookings.stepModelFunds"),
          value: "stepModelFunds",
        },
      ];
    },

    items() {
      return map(({ funds, user }) => {
        return {
          user: user,
          address: {
            name: user.useBillingAddress ? user.company.billingAddress.name : user.company.address.name,
            address: user.useBillingAddress ? user.company.billingAddress.address : user.company.address.address,
            contactPerson: user.useBillingAddress
              ? user.company.billingAddress.contactPerson
              : user.company.address.contactPerson,
            city: user.useBillingAddress ? user.company.billingAddress.city : user.company.address.city,
            country: user.useBillingAddress ? user.company.billingAddress.country : user.company.address.country,
            zip: user.useBillingAddress ? user.company.billingAddress.zip : user.company.address.zip,
            vatId: user.useBillingAddress ? user.company.billingAddress.vatId : user.company.address.vatId,
            billingLanguage: user.useBillingAddress
              ? user.company.billingAddress.billingLanguage
              : user.company.address.billingLanguage,
          },
          minimalFunds: join(", ", pluck("name", filter(propEq("stepModel", false), funds))),
          minimalFundsCount: length(filter(propEq("stepModel", false), funds)),
          stepModelFunds: join(", ", pluck("name", filter(propEq("stepModel", true), funds))),
          stepModelFundsCount: length(filter(propEq("stepModel", true), funds)),
          emails: join(", ", [user.email, ...(user.emails || [])]),
        };
      }, this.auditPeriods);
    },

    totals() {
      return {
        minimal: sum(pluck("minimalFundsCount", this.items)),
        stepModel: sum(pluck("stepModelFundsCount", this.items)),
      };
    },
  },

  methods: {
    generateCsv() {
      const paths = map(split("."), pluck("value", this.headers));
      const header = pluck("text", this.headers);
      const rows = map((item) => map((p) => path(p, item), paths), this.items);

      return stringify([header, ...rows], { header: false });
    },

    downloadCsv() {
      saveAs(new Blob([this.generateCsv()], { type: "text/plain;charset=utf-8" }), `bookings_${this.year}.csv`);
    },
  },
};
</script>
